import { useTranslate } from "@similarweb/i18n-provider";

import QuotaTag, { type QuotaTagSize } from "app/pages/sales-intelligence/modules/quota/components/QuotaTag";
import { quotaKeys } from "app/pages/sales-intelligence/modules/quota/utils/i18n";
import { formatCompactNumber } from "app/pages/sales-intelligence/utils/numbers";

type Props = {
    size?: QuotaTagSize;
    isOutOfQuota: boolean;
    totalCost: number;
};

const QuotaTotalCost = ({ size = "sm", totalCost, isOutOfQuota }: Props) => {
    const { translate } = useTranslate();

    const totalCostKey = quotaKeys.totalCost({ creditNumber: formatCompactNumber(totalCost) });

    return (
        <QuotaTag
            size={size}
            type={isOutOfQuota ? "warning" : "light"}
            title={translate(totalCostKey.key, totalCostKey.replacements)}
        />
    );
};

export default QuotaTotalCost;
